import React from 'react';
import styled from 'styled-components';
import { PROFIL_CREATEUR_OPTIONS } from '../sdeConstants';

const StepContainer = styled.div`max-width: 700px; margin: 0 auto;`;
const StepTitle = styled.h2`font-size: 1.5rem; font-weight: 600; color: #1F2937; margin-bottom: 0.5rem;`;
const StepSubtitle = styled.p`color: #6B7280; margin-bottom: 2rem; font-size: 0.95rem;`;
const FormGroup = styled.div`margin-bottom: 1.5rem;`;
const Label = styled.label`
  display: block; font-size: 0.95rem; font-weight: 500; color: #374151; margin-bottom: 0.4rem;
  ${props => props.required && `&::after { content: ' *'; color: #EF4444; }`}
`;
const Hint = styled.p`font-size: 0.85rem; color: #9CA3AF; margin: 0.25rem 0 0.5rem;`;
const Textarea = styled.textarea`
  width: 100%; padding: 0.75rem 1rem; font-size: 0.95rem; border: 2px solid #E5E7EB; border-radius: 8px;
  background: #F9FAFB; min-height: 100px; resize: vertical;
  &:focus { outline: none; border-color: #2563EB; background: white; }
`;

const SectionCard = styled.div`
  background: #F0F4FF; border: 2px solid #C7D2FE; border-radius: 12px; padding: 1.5rem; margin-bottom: 1.5rem;
`;
const SectionTitle = styled.div`
  font-size: 0.95rem; font-weight: 600; color: #374151; margin-bottom: 10px;
  ${props => props.required && `&::after { content: ' *'; color: #EF4444; }`}
`;
const CheckboxGroup = styled.div`
  display: flex; flex-direction: column; gap: 2px;
`;
const CheckboxLabel = styled.label`
  display: flex; align-items: center; gap: 8px; font-size: 0.85rem; color: #374151;
  cursor: pointer; padding: 2px 6px; border-radius: 4px; transition: background 0.15s;
  margin: 0; line-height: 1.2;
  &:hover { background: #E0E7FF; }
  input[type="checkbox"] { width: 16px; height: 16px; accent-color: #2563EB; cursor: pointer; margin: 0; }
`;

const PopBStep2_Expertise = ({ data, updateData, lang = 'fr' }) => {
  const metadata = data.metadata || {};
  const profilList = metadata.profil_createur || [];

  const updateMeta = (field, value) => {
    updateData({ metadata: { ...data.metadata, [field]: value } });
  };

  const handleProfilToggle = (value) => {
    const next = profilList.includes(value)
      ? profilList.filter(v => v !== value)
      : [...profilList, value];
    updateMeta('profil_createur', next);
  };

  return (
    <StepContainer>
      <StepTitle>{lang === 'fr' ? 'Votre expertise professionnelle' : 'Your Professional Expertise'}</StepTitle>
      <StepSubtitle>
        {lang === 'fr'
          ? 'Décrivez votre profil et vos compétences de créateur'
          : 'Describe your profile and creative skills'}
      </StepSubtitle>

      <SectionCard>
        <SectionTitle required>
          {lang === 'fr' ? 'Profil du créateur' : 'Designer profile'}
        </SectionTitle>
        <Hint>{lang === 'fr' ? 'Cochez au moins une option' : 'Check at least one option'}</Hint>
        <CheckboxGroup>
          {PROFIL_CREATEUR_OPTIONS.map(opt => (
            <CheckboxLabel key={opt.value}>
              <input
                type="checkbox"
                checked={profilList.includes(opt.value)}
                onChange={() => handleProfilToggle(opt.value)}
              />
              {lang === 'fr' ? opt.label_fr : opt.label_en}
            </CheckboxLabel>
          ))}
        </CheckboxGroup>
      </SectionCard>

      <FormGroup>
        <Label required>{lang === 'fr' ? 'Savoir-faire et spécialités' : 'Know-how and specialties'}</Label>
        <Hint>
          {lang === 'fr'
            ? 'Décrivez vos domaines d\'expertise, spécialités et types de projets'
            : 'Describe your areas of expertise, specialties and project types'}
        </Hint>
        <Textarea
          value={metadata.savoir_faire || ''}
          onChange={e => updateMeta('savoir_faire', e.target.value)}
          placeholder={lang === 'fr'
            ? 'Ex: Design mobilier, architecture d\'intérieur, scénographie, design d\'espace...'
            : 'E.g., Furniture design, interior architecture, scenography, space design...'}
        />
      </FormGroup>

      <FormGroup>
        <Label>{lang === 'fr' ? 'Matériaux et techniques' : 'Materials and techniques'}</Label>
        <Hint>
          {lang === 'fr'
            ? 'Les matériaux et techniques avec lesquels vous travaillez'
            : 'Materials and techniques you work with'}
        </Hint>
        <Textarea
          value={metadata.materiaux_techniques || ''}
          onChange={e => updateMeta('materiaux_techniques', e.target.value)}
          placeholder={lang === 'fr'
            ? 'Ex: Bois, métal, textile, céramique, impression 3D...'
            : 'E.g., Wood, metal, textile, ceramic, 3D printing...'}
        />
      </FormGroup>

      <FormGroup>
        <Label>{lang === 'fr' ? 'Démarche créative' : 'Creative approach'}</Label>
        <Hint>
          {lang === 'fr'
            ? 'Décrivez brièvement votre approche et votre style'
            : 'Briefly describe your approach and style'}
        </Hint>
        <Textarea
          value={metadata.demarche_creative || ''}
          onChange={e => updateMeta('demarche_creative', e.target.value)}
          placeholder={lang === 'fr'
            ? 'Votre démarche, vos influences, votre positionnement...'
            : 'Your approach, influences, positioning...'}
        />
      </FormGroup>
    </StepContainer>
  );
};

export default PopBStep2_Expertise;
